import router from "@/router";

export function getRoute(pageName) {
    return router.getRoutes().find((r) => r.name === pageName);
}
